<ng-container *transloco="let t; prefix: scope">
  <div style="margin: auto; width: 35%">
    <p-dialog
      [visible]="true"
      [style]="{ width: '600px' }"
      [resizable]="false"
      [closable]="false"
      [modal]="true"
      [showHeader]="false"
      [draggable]="false">
      <h3 class="text-center mt-12">{{ t('welcomeToFirmSupport') }}</h3>
      <div *ngIf="(loggingIn$ | async) === false; else loggingInTemplate">
        <p style="font-size: 120%; text-align: center">
          {{ t('loginToContinue') }}<br /><br /><i
            class="fas fa-sign-in-alt fa-5x faa-pulse animated"
            aria-hidden="true"
            (click)="login()"
            [title]="t('login')"
            style="padding-right: 20px; cursor: pointer; color: green"></i>
        </p>
      </div>
      <ng-template #loggingInTemplate>
        <div style="font-size: 120%; text-align: center" class="pt-12 pb-4">
          <div class="flex justify-center">
            <img src="./assets/ajax-loader.gif" [alt]="t('loggingInPleaseWait')" />
          </div>
          <br />{{ t('loggingInPleaseWait') }}
        </div>
      </ng-template>
      <br />
      <div class="text-center">
        <div class="flex justify-center">
          <img class="py-4" src="/assets/BL-Landscape.png" alt="Bjorn Lunden" />
        </div>
        {{ t('loginFooter') }}
      </div>
    </p-dialog>
  </div>
</ng-container>
